const API_DOMAIN = "https://exi-bo.hoyou.xyz/";
let EVENT_ID = null;

let players = [];
let currentWinner = null;
let spinning = false;
let currentVote = null;

// --- Match new project IDs ---
const drawButton = document.getElementById("drawButton");
const spinnerContainer = document.querySelector(".spinner-container");
const placeholderText = spinnerContainer?.querySelector(".placeholder");
const modal = document.getElementById("modal");
const modalCloseButton = document.getElementById("modalCloseButton");
const modalAssignButton = document.getElementById("modalAssignButton");
const modalWinnerName = document.getElementById("winnerName");
const loadingScreen = document.getElementById("loadingScreen");
const select = document.querySelector(".select");
const options = document.querySelector(".options");
const selectP = document.querySelector(".select > p");
const optionsItems = document.querySelectorAll(".options > li");

// --- Utility ---
function sleep(ms) {
  return new Promise((r) => setTimeout(r, ms));
}

function showLoading(show) {
  if (!loadingScreen) return;
  if (show) {
    loadingScreen.classList.remove("hidden");
  } else {
    loadingScreen.classList.add("hidden");
  }
}

// --- select ---
select.addEventListener("click", () => {
    select.classList.toggle("expanded");
});

optionsItems.forEach(item => {
    item.addEventListener("click", (e) => {
        e.stopPropagation();

        currentVote = Number(e.target.value);
        loadParticipants();
        const clickedItem = e.currentTarget;
        
        optionsItems.forEach(opt => opt.classList.remove("selected"));

        selectP.innerHTML = clickedItem.innerHTML;
        clickedItem.classList.add("selected");

        select.classList.remove("expanded");
    })
})

// --- Check Event Status ---
async function checkEventStatus() {
  try {
    showLoading(true);
    const res = await fetch(`${API_DOMAIN}api/event/list`);
    const data = await res.json();
    await sleep(500); // 0.5s visible minimum for loading animation

    if (data.message === "success" && Array.isArray(data.data) && data.data.length > 0) {
      const event = data.data[0];
      EVENT_ID = event.id;
      if (event.status === 4) {
        if (currentVote !== null) {
          await loadParticipants();
        }
      } else {
        window.location.href = "eventClosed.html";
      }
    } else {
      window.location.href = "eventClosed.html";
    }
  } catch (err) {
    console.error("Error checking event:", err);
    window.location.href = "eventClosed.html";
  } finally {
    showLoading(false);
  }
}

// --- Load Participants ---
async function loadParticipants() {
  try {
    showLoading(true);
    const res = await fetch(`${API_DOMAIN}api/internal/vote/participants`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ eventId: EVENT_ID, vote: currentVote }),
    });
    const result = await res.json();
    // await sleep(100);

    if (result.message === "success" && result.data?.available) {
      players = result.data.available.map((p) => p.ticketId);
      console.log("Available participants:", players);
      drawButton.disabled = players.length === 0;
    } else {
      drawButton.disabled = true;
      console.warn("No participants found.");
    }
  } catch (err) {
    console.error("Error loading participants:", err);
    drawButton.disabled = true;
  } finally {
    showLoading(false);
    if (placeholderText) {
      placeholderText.textContent = "Who's lucky one?";
    }
  }
}

// --- Draw Button Click ---
drawButton?.addEventListener("click", async () => {
  // No player selected → show warning
  if (currentVote === null) {
    alert("Please select a Player");
    select.classList.toggle("expanded");
    return;
  }

  if (spinning || players.length === 0) return;
  spinning = true;
  drawButton.disabled = true;

  if (placeholderText) placeholderText.textContent = "";

  spinnerContainer.style.position = "relative";
  spinnerContainer.style.overflow = "hidden";
  spinnerContainer.style.display = "block";

  // Create scrolling list
  spinnerContainer.innerHTML = `
    <div class="scroll-list" style="
      position: absolute;
      left: 0;
      width: 100%;
      text-align: center;
      font-size: 65px;
      line-height: 100px;
      font-weight: 900;
      color: #000;
      transform: translateY(0);
    ">
      ${players.map((p) => `<div>${p}</div>`).join("")}
    </div>
  `;

  const listEl = spinnerContainer.querySelector(".scroll-list");
  const itemHeight = 100;
  const totalRounds = 8;
  const spinDuration = 4.5;
  const randomIndex = Math.floor(Math.random() * players.length);

  // offset ensures list starts centered vertically inside capsule
  const containerHeight = spinnerContainer.offsetHeight;
  const centerOffset = containerHeight / 2 - itemHeight / 2;
  listEl.style.top = `${centerOffset}px`;

  // extend list
  const extendedList = [];
  for (let i = 0; i < totalRounds + 2; i++) extendedList.push(...players);
  listEl.innerHTML = extendedList.map((p) => `<div>${p}</div>`).join("");

  const finalOffset = (players.length * totalRounds + randomIndex) * itemHeight;

  // force reflow before animation
  listEl.offsetHeight;

  // animate scroll
  requestAnimationFrame(() => {
    listEl.style.transition = `transform ${spinDuration}s cubic-bezier(0.05, 0.9, 0.25, 1)`;
    listEl.style.transform = `translateY(-${finalOffset}px)`;
  });

  await new Promise((r) => setTimeout(r, spinDuration * 1000 + 300));

  // --- Winner ---
  currentWinner = players[randomIndex];
  modalWinnerName.textContent = currentWinner;
  showModal();

  // Reset to show only winner name centered
  listEl.style.transition = "none";
  listEl.style.transform = "translateY(0)";
  listEl.innerHTML = `
    <div style="
      font-size: 65px;
      font-weight: 900;
      color: #000;
      line-height: 100px;
      text-align: center;
    ">${currentWinner}</div>
  `;

  spinnerContainer.style.display = "flex";
  spinnerContainer.style.alignItems = "center";
  spinnerContainer.style.justifyContent = "center";

  spinning = false;
  drawButton.disabled = false;
});

// --- Popup Logic ---
function showModal() {
  if (!modal) return;
  modal.classList.add("active");
}

function hideModal() {
  if (!modal) return;
  modal.classList.remove("active");
}

modalCloseButton?.addEventListener("click", async () => {
  await sendWinStatus(0);
});

modalAssignButton?.addEventListener("click", async () => {
  await sendWinStatus(1);
});

async function sendWinStatus(winValue) {
  try {
    await fetch(`${API_DOMAIN}api/internal/voter/win`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        eventId: EVENT_ID,
        ticketId: currentWinner,
        win: winValue,
      }),
    });
  } catch (err) {
    console.error("Error sending win status:", err);
  } finally {
    hideModal();
    await loadParticipants();
  }
}

// --- Init ---
document.addEventListener("DOMContentLoaded", async () => {
  showLoading(true);
  await sleep(300);
  checkEventStatus();
});
